// ----------------------------------------------------------------------
export const Input = ({ theme }) => {
    return {
        // MuiInput
        MuiInputBase: {
            styleOverrides: {
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        color: theme.palette.text.disabled
                    }
                }
            }
        },
        MuiInput: {
            styleOverrides: {
                underline: {
                    '&:before': {
                        borderBottomColor: theme.palette.grey[50056]
                    }
                }
            }
        },
        // Filled Input
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.grey[50012],
                    '&:hover': {
                        backgroundColor: theme.palette.grey[50016]
                    },
                    '&$focused': {
                        backgroundColor: theme.palette.grey[50012]
                    },
                    '&$disabled': {
                        backgroundColor: theme.palette.divider
                    }
                },
                underline: {
                    '&:before': {
                        borderBottomColor: theme.palette.grey[50056]
                    }
                }
            }
        },
        // Outlined Input
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '&$disabled': {
                        '& $notchedOutline': {
                            borderColor: theme.palette.divider
                        }
                    }
                },
                notchedOutline: {
                    borderColor: theme.palette.grey[50032]
                }
            }
        }
    };
};
//# sourceMappingURL=Input.js.map